export default [
  {
    name: 'preInquiryPatientDetails',
    path: 'preInquiryPatientDetails',
    component: () =>
      import(
        /* webpackChunkName: 'preInquiryPatientDetails' */
        '../views/preInquiry/patientDetails/index.vue'
      ),
  },
  {
    name: 'preInquiryDetail',
    path: 'preInquiryDetail',
    component: () =>
      import(
        /* webpackChunkName: 'preInquiryDetail' */
        '../views/preInquiry/detail/index.vue'
      ),
    meta: {
      keepAlive: true,
    },
  },
];
